import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { snakSettings } from '../data/proposal';
type IntroStatementProps = {
  onOpenConcept: () => void;
};
export function IntroStatement({
  onOpenConcept
}: IntroStatementProps) {
  return <section aria-labelledby="intro-title" className="max-w-[480px] text-ink" data-id="element-105" data-mp="xy7563a4lyf3">
      <p className="font-mono text-[11px] font-medium tracking-[0.22em] text-teal" data-id="element-106" data-mp="12w8x7dpj582p">AN INSPIRATION. NOT A RECOMMENDATION.</p>
      <h1 id="intro-title" className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.035em] lg:text-[40px]" data-id="element-107" data-mp="ozvgi6stlapa">
        The right Snak starts with <span className="text-graphite" data-id="element-108" data-mp="f0ecdtt7v4vf">the right challenge.</span>
      </h1>

      <div className="mt-5 space-y-2.5 text-[15.5px] leading-[1.6] text-graphite" data-id="element-109" data-mp="jypipukayx8w">
        <p data-id="element-110" data-mp="k0it9ky1e1m6">
          Every brand faces different challenges. Sometimes it’s creating awareness. Sometimes it’s{' '}
          <strong className="font-semibold text-ink" data-id="element-111" data-mp="2ecgtixedbn5x">changing established perceptions</strong>, explaining complex evidence or
          building confidence in treatment decisions.
        </p>
        <p data-id="element-112" data-mp="3vihbes8swr83">
          <strong className="font-semibold text-ink" data-id="element-113" data-mp="3vir6uvcm7ql6">New clinical data</strong> can give an established treatment a fresh
          opportunity to change perceptions.
        </p>
        <p data-id="element-114" data-mp="e3sp32fc87o9">
          Inspired by the recent German MINT results, we’ve imagined how a short, interactive Snak could bring that evidence to
          life and explore its relevance for patients and clinical decisions.
        </p>
        <p data-id="element-115" data-mp="3ck55dfd6rxgq">
          This example was developed <strong className="font-semibold text-ink" data-id="element-116" data-mp="3cl6hln5xuq01">independently, without a brief</strong> from Kyowa
          Kirin. It’s intended to inspire a conversation, not recommend a predefined campaign.
        </p>
      </div>

      <button type="button" onClick={onOpenConcept} className="group mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-navy px-5 py-2.5 text-[14px] font-medium text-white shadow-[0_8px_20px_-10px_rgba(30,58,95,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-ink active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy" data-id="element-117" data-mp="3mk5p32eywflg">
        Explore the concept &amp; other ideas
        <ArrowRightIcon size={15} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-118" data-mp="cgfl4edmjl7k" />
      </button>

      <div className="mt-6 border-t border-ink/10 pt-5" data-id="element-119" data-mp="3bxdxdmoh1wny">
        <p className="text-[13px] font-semibold text-ink" data-id="element-120" data-mp="3gtuo8on22p4q">Where a Snak can work</p>
        <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-121" data-mp="3kvplni1v8id8">
          {snakSettings.map(s => <li key={s} className="whitespace-nowrap rounded-full border border-ink/10 bg-white px-3 py-1 text-[12.5px] text-ink" data-id="element-122" data-mp="3pmpk4rqmv8hu">
              {s}
            </li>)}
        </ul>
      </div>

      <div className="mt-6 border-l-2 border-navy pl-4" data-id="element-123" data-mp="2x6eqcg3abg6h">
        <p className="text-[17px] font-medium leading-snug tracking-[-0.01em] text-ink" data-id="element-124" data-mp="2x4tv0o95bt7k">
          Let’s find where we could make the biggest difference for Poteligeo®.
        </p>
      </div>

      <p className="mt-6 text-[11px] leading-snug text-graphite/70" data-id="element-125" data-mp="2kou8ogk4tf1b">
        Illustrative concept based on publicly available information.
        <br data-id="element-126" data-mp="2bnmmuxysy6o4" />
        Idea, concept &amp; creative direction © Snakker™ 2026 · Confidential &amp; proprietary.
      </p>
    </section>;
}